(function ($) {


    $(document).on('click', '.followme-contact-content-dzial-title', function () {
        var parent = $(this).parent();

        if(parent.hasClass("opened")){
            parent.find(".followme-contact-content-dzial-content").slideUp();
            parent.find(".followme-contact-content-dzial-icon").removeClass("fa-chevron-up").addClass("fa-chevron-right");
            parent.removeClass("opened");
        } else {
            parent.find(".followme-contact-content-dzial-content").slideDown();
            parent.find(".followme-contact-content-dzial-icon").removeClass("fa-chevron-right").addClass("fa-chevron-up");
            parent.addClass("opened");
        }
    });

})(jQuery);